export const discountTypes = {
  ADVANCE_BOOKING: 'advance_booking',
};
